<template>
  <div class="filter_layer" id="filter_layer">
    <div :class="($store.state.isLoader)?'loader opened':'loader'" v-show="$store.state.isLoader">
      <div class="bull">Chargement...</div>
    </div>
    <v-app>
      <v-app-bar
        app
        color="white"
        scroll-threshold="100"
        fixed
        min-height="60"
        flat
        class="appbar"
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        :style="'transform:translateY('+(($store.state.offsetTop < 0)? Math.abs($store.state.offsetTop) : 0)+'px);'"
      >
        <div class="pullToReefresh">
          <div class="motion">rafraîchir</div>
        </div>
        <!--  
          padding-top:'+(($store.state.offsetTop < 0)? Math.abs($store.state.offsetTop) : 0)+'px;
        transform:translateY('+(($store.state.offsetTop < 0)?Math.abs($store.state.offsetTop):0)+'px);-->
        <v-progress-linear
          indeterminate
          color="primary"
          style="position:absolute; top:0; width:100%; left:0;"
          v-if="isLoading"
        ></v-progress-linear>

        <div style="height:100%; width:48px;" align="center">
          <v-img v-ripple color="primary" @click="openClose" :src="iconHamburger" v-if="!menu"></v-img>
          <v-img v-ripple color="primary" @click="openClose" :src="iconCross" v-if="menu"></v-img>
        </div>
        <div
          style="height:64px; text-align:left; visibility:visible !important; display:block !important; min-width:100px !important"
        >
          <!-- <div class="d-flex align-center"> -->
          <router-link to="/">
            <img
              alt="Bige logo"
              class="shrink mt-1"
              contain
              :src="logo"
              style="margin-top:10px !important; height:45px; width:auto; max-width:200px; min-width:100px; transform: translateZ(0);"
              width="100"
              min-width="50"
              max-height="50"
            />
          </router-link>
        </div>
        <v-spacer></v-spacer>

        <!-- 
        <v-btn href="https://github.com/vuetifyjs/vuetify/releases/latest" target="_blank" text>
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
        position:absolute; bottom:20px;
        -->
        <DayNight :checked="false"></DayNight>
        <CircleProgress v-if="$route.name && $route.name.indexOf('Article Details') !== -1" style></CircleProgress>
      </v-app-bar>
      <v-navigation-drawer app v-model="menu" :clipped="$vuetify.breakpoint.lgAndUp">
        <!-- -->
        <v-list-item style="padding:0; margin:0;">
          <v-list-item-content style="padding:0px; margin:0;">
            <v-list-item
              v-if="$store.state.userProfile"
              class="px-2"
              to="/account"
              style="padding:10px; margin:0;"
            >
              <v-list-item-avatar color="grey">
                <v-img :src="$store.state.userProfile.photoURL"></v-img>
              </v-list-item-avatar>

              <v-list-item-title>
                Bonjour
                <br />
                {{$store.state.userProfile.displayName}}
              </v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="!$store.state.userProfile"
              class="px-2"
              v-on:click="$store.state.loginDialog = true;"
              style="padding:10px; margin:0;"
            >
              <v-list-item-avatar color="white">
                <v-img :src="iconAccount"></v-img>
              </v-list-item-avatar>

              <v-list-item-title>
                Connexion
                <br />Créer un compte
              </v-list-item-title>
            </v-list-item>
          </v-list-item-content>
        </v-list-item>
        <v-divider style="margin:0;"></v-divider>

        <v-list dense class="navList">
          <template v-for="item in items">
            <v-row v-if="item.heading" :key="item.heading" align="center">
              <v-col cols="6">
                <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
              </v-col>
              <v-col cols="6" class="text-center">
                <a href="#!" class="body-2 black--text">EDIT</a>
              </v-col>
            </v-row>
            <v-list-group
              v-else-if="item.children"
              :key="item.text"
              v-model="item.model"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item v-for="(child, i) in item.children" :key="i" link :to="child.to">
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ child.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <v-list-item v-else :key="item.text" link :to="item.to" color="primary">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>

        <!-- <router-link to="/">home</router-link>
        <router-link to="/about">about</router-link>-->
      </v-navigation-drawer>
      <!-- <v-sheet id="content-scroll-target" class="overflow-y-auto" max-height="100vh"> -->
      <v-content>
        <router-view></router-view>
      </v-content>

      <v-snackbar v-model="messagingBar" color="primary">
        <div v-if="message.type=='level'">NOUVEAU LEVEL {{ message.type }} {{ message.coins }}</div>
        <div v-if="message.type=='progression'">
          Nouvelle progression {{message.name}}
          <br />
          {{ message.count }} / {{ message.objective }}
        </div>
        <!-- message : {
        "coins":0,
        "count":4,
        "label":"Progression",
        "level":2,
        "message":"nouvelle progression",
        "name":"comment","
        objective":5,
        "time":1587648384369,
        "type":"progression",
        "id":"7LHjLMPHpZ8QZbgbeVcA"} 
        -->

        <v-btn color="white" text to="/account">Mon compte</v-btn>
        <v-btn color="white" text @click="messagingBar = false">Close</v-btn>
      </v-snackbar>
      <InstallPWA></InstallPWA>
      <!-- </v-sheet> -->
    </v-app>
    <LoginDialog></LoginDialog>
    <div class="koanmi" id="konami" v-if="konami">KONAMI</div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";

import logoWhite from "@/assets/images/logo-blue.svg";
import iconHamburger from "@/assets/images/icons/bige-icon-hamburger.svg";
import iconCross from "@/assets/images/icons/bige-icon-cross.svg";
import CircleProgress from "@/components/UI/CircleProgress";
import DayNight from "@/components/UI/DayNight";
import iconAccount from "@/assets/images/icons/bige-icon-account.svg";
import LoginDialog from "@/components/Login/LoginDialog.vue";
import InstallPWA from "@/components/UI/standalonePWA.vue";
/* const Lottie = () => import("@/components/LottieMotion.vue");
import * as PullToRefresh from "@/assets/motions/UI/pulltorefresh.json"; */

const fb = require("@/config/firebaseConfig");

import {
  // mdiFileWordBox,
  mdiShareVariant,
  mdiChevronUp,
  mdiChevronDown,
  mdiInformationOutline,
  mdiEmail,
  mdiFile,
  // mdiCamera,
  // mdiBarcode,
  mdiHeadSnowflakeOutline,
  mdiRemoteDesktop,
  mdiTransition,
  mdiPencilRuler,
} from "@mdi/js";
//import IconWordBox from "mdi-file-word-box";

export default {
  name: "Bige",
  components: { CircleProgress, LoginDialog, DayNight, InstallPWA },
  methods: {
    touchEnd() {
      if (window.scrollY < -100) {
        window.location.reload();
      }
    },
    onScroll() {
      this.offsetTop = window.scrollY;
      this.$store.commit("offsetTop", window.scrollY);
      this.scroll = window.scrollY;
      if (window.scrollY < 0 && document.querySelector(".articles_list_tabs")) {
        document.querySelector(".articles_list_tabs").style.transform =
          "translateY(" + Math.abs(window.scrollY) + "px)";
      } else if (document.querySelector(".articles_list_tabs")) {
        document.querySelector(".articles_list_tabs").style.transform =
          "translateY(0px)";
      }
      /* if (this.konami)
        if (!this.ticking) {
          window.requestAnimationFrame(
            function() {
              // ACTIONS HERE
              this.ticking = false;
            }.bind(this)
          );
          this.ticking = true;
        } */
    },
    openClose() {
      this.$store.commit("setMenu");
    },
    handleAnimation: function (anim) {
      this.anim = anim;
    },
    stop: function () {
      this.anim.stop();
    },
    play: function () {
      this.anim.play();
    },
    pause: function () {
      this.anim.pause();
    },
    onSpeedChange: function () {
      this.anim.setSpeed(this.animationSpeed);
    },
    getHeight: function (scrollPos) {
      if (scrollPos < 0) {
        return 64 + Math.abs(scrollPos);
      } else {
        return 64;
      }
    },
  },
  computed: {
    // eslint-disable-next-line no-undef

    message: {
      get: function () {
        if (!this.$store.state.userMessages) return "";
        let data = this.$store.state.userMessages;
        if ((new Date().getTime() - data[data.length - 1].time) / 1000 < 2)
          return data[data.length - 1];
        // alert(JSON.stringify(data[data.length - 1]));
        return "";
      },
      set: function (value) {
        this.$store.state.userMessages = value;
      },
    },
    konami: {
      get: function () {
        return this.$store.state.konami;
      },
      set: function (value) {
        this.$store.state.konami = value;
      },
    },
    menu: {
      get: function () {
        return this.$store.state.menu;
      },
      set: function (value) {
        this.$store.state.menu = value;
      },
    },
    isLoading: {
      get: function () {
        return this.$store.state.isLoading;
      },
      set: function (value) {
        this.$store.state.isLoading = value;
      },
    },
  },
  watch: {
    menu() {
      return this.$store.state.menu;
    },
    konami() {
      if (document.getElementById("filter_layer").classList.contains("invert"))
        document.getElementById("filter_layer").classList.remove("invert");
      else document.getElementById("filter_layer").classList.add("invert");
      return this.$store.state.konami;
    },
    isLoading() {
      return this.$store.state.isLoading;
    },
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      /* if (typeof to.hash !== "undefined" && to.hash !== "") {
        if (document.getElementById(to.hash.replace("#", ""))) {
        }
      } */
    },
    // eslint-disable-next-line no-unused-vars
    message(newmsg, old) {
      this.messagingBar = true;
    },
  },
  data: () => ({
    messagingBar: false,
    /* pullToRefresh: {
      animationData: PullToRefresh.default,
      loop: false,
      autoplay: false
    }, */
    defaultOptions: {
      // animationData: animationData.default,
      loop: false,
    },
    iconHamburger: iconHamburger,
    iconAccount: iconAccount,
    iconCross: iconCross,
    animationSpeed: 1,
    logo: logoWhite,
    offsetTop: 0,
    autoplay: true,
    loop: true,
    items: [
      { icon: mdiShareVariant, text: "Les postits Bige", to: "/feeds" },
      /* { icon: "mdi-information-outline", text: "Welcomer", to: "/welcomer" },
      {
        icon: "mdi-cellphone-link",
        text: "Chrome extension",
        to: "/extension"
      }, */

      /* {
        icon: mdiFileWordBox,
        text: "Parallax",
        to: "/parallax"
      }, */
      {
        icon: mdiChevronUp,
        "icon-alt": mdiChevronDown,
        text: "About",
        model: true,
        to: "/",
        children: [
          {
            icon: mdiInformationOutline,
            text: "Bige ?",
            to: "/",
          },
          {
            icon: mdiHeadSnowflakeOutline,
            text: "Ateliers UX",
            to: "/about/ateliers",
          },
          {
            icon: mdiPencilRuler,
            text: "Création & UI",
            to: "/about/uiux",
          },
          {
            icon: mdiRemoteDesktop,
            text: "Développement",
            to: "/about/developpement",
          },
          {
            icon: mdiTransition,
            text: "Animation & vidéo",
            to: "/about/motion",
          },
        ],
      },
      {
        icon: mdiEmail,
        text: "Contact",
        to: "/contact",
      } /* ,
      {
        icon: mdiChevronUp,
        "icon-alt": mdiChevronDown,
        text: "Expérience & tests",
        model: true,
        to: "/experiences",
        children: [
          {
            icon: mdiFileWordBox,
            text: "Bige Word Lab",
            to: "/search"
          },
          {
            icon: mdiCamera,
            text: "Bige Camera",
            to: "/camera"
          },
          {
            icon: mdiBarcode,
            text: "Bige Barcode Scanner",
            to: "/barcode"
          }
        ]
      } */,
      { icon: mdiFile, text: "API Documentation", to: "/documentation" },
      {
        icon: mdiTransition,
        text: "Conditions d'utilisation",
        to: "/cgu",
      },
    ],
  }),
  created() {
    let redirects = [
      "https://bige-start.firebaseapp.com",
      "https://bige.dev",
      "https://bige-start.web.app",
    ];
    if (redirects.includes(window.location.origin)) {
      location.href = "https://www.bige.dev";
    }
    const url = location.href;
    const email = window.localStorage.getItem("emailForSignIn");
    var _self = this;
    if (window.localStorage.getItem("emailForSignIn") !== null) {
      if (firebase.auth().isSignInWithEmailLink(url)) {
        firebase
          .auth()
          .signInWithEmailLink(email, url)
          .then(async function (result) {
            // Clear email from storage.
            window.localStorage.removeItem("emailForSignIn ");
            // You can access the new user via result.user
            // Additional user info profile not available via:
            // result.additionalUserInfo.profile == null
            // You can check if the user is new or existing:
            // result.additionalUserInfo.isNewUser
            _self.$store.commit("setCurrentUser", result.user);
            // await store.dispatch('getAccess ', user);
            await _self.$store.dispatch("fetchUserProfile");
            await _self.$store.dispatch("fetchRules");
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function (error) {
            // Some error occurred, you can inspect the code: error.code
            // Common errors could be invalid email and invalid or expired OTPs.
          });
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, true);
    window.addEventListener("touchend", this.touchEnd, true);
    // eslint-disable-next-line no-undef

    if (Notification) {
      if (fb.messaging) {
        try {
          // eslint-disable-next-line no-undef
          // eslint-disable-next-line no-unused-vars
          fb.messaging.onMessage(function (payload) {
            // ...
          });
        } catch (err) {
          console.log("notifications error ", err);
        }
      } else {
        console.log("THERE IS NO MESSAGING");
      }
    } else {
      console.log("THERE IS NO MESSAGING");
    }
    // TODO ONLY A TEST LOG DO NOT PUSH ON PRODUCTION MODE
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/service-worker.js").then(function () {
        console.log("Service Worker Registered !!!!!!!!!!!!!!!!!!");
      });
    }

    if (window.navigator && navigator.serviceWorker) {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        console.log("service worker registrations ", registrations);
        for (let registration of registrations) {
          registration.unregister();
        }
      });
    }
  },
};
</script>
<style scoped>
.filter_layer {
  background: white;
  /* transition: filter 0.4s linear; */
  /* filter: invert(0) grayscale(0) hue-rotate(0deg) saturate(1); */
}
.filter_layer.hue {
  filter: hue-rotate(45deg);
}
.filter_layer.grayscale {
  filter: grayscale(1);
}
.filter_layer.invert {
  filter: invert(1) grayscale(0.9) hue-rotate(150deg) saturate(10);
}

.filter_layer.invert code {
  filter: invert(1);
}
</style>
